const carouselItems = [
  {
    title: '系统流韩漫巅峰对决',
    subtitle: '从E级到SSS级的逆袭之路',
    desc: '《我独自升级》《SSS级猎人》《全知读者视角》——系统流韩漫的三大天花板，每一部都让人欲罢不能。暗影君主、双职业猎人、全知视角，你更爱哪一种逆袭？',
    tag: '专题企划',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20system%20genre%20illustration%20with%20fantasy%20hunter%20characters%20in%20dark%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20warm%20coral%20and%20deep%20shadow%20contrast%2C%20cinematic%20composition%2C%20manhwa%20cover%20art%20style&width=1000&height=560&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫武侠：一剑破万法',
    subtitle: '东方玄幻的极致美学',
    desc: '《剑道第一仙》《一念永恒》《完美世界》——国漫武侠玄幻的巅峰之作，水墨意境与现代作画完美融合，每一帧都是视觉盛宴。',
    tag: '国漫专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20illustration%20with%20swordsman%20in%20flowing%20robes%2C%20ink%20wash%20painting%20style%2C%20mountain%20and%20cloud%20background%2C%20elegant%20warm%20golden%20tones%2C%20cinematic%20widescreen%20composition&width=1000&height=560&seq=carousel-02&orientation=landscape',
  },
  {
    title: '日漫神作永不落幕',
    subtitle: '少年Jump的黄金时代',
    desc: '《鬼灭之刃》《咒术回战》《海贼王》《我的英雄学院》——这些承载了无数人青春的日漫神作，在番茄漫画都可以免费畅读。重温经典，感受热血。',
    tag: '日漫专题',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20epic%20illustration%20with%20dynamic%20action%20characters%2C%20vibrant%20red%20and%20warm%20tones%2C%20explosive%20energy%2C%20cinematic%20composition%2C%20anime%20style%20art%2C%20dramatic%20lighting&width=1000&height=560&seq=carousel-03&orientation=landscape',
  },
  {
    title: '穿越异世界恋爱图鉴',
    subtitle: '换个身份遇见命中注定',
    desc: '《某天成为公主》《公爵的契约未婚妻》《恶役只有死亡结局》——穿越到异世界成为女主，宫廷权谋与浪漫交织，高甜恋爱让人心动不已。',
    tag: '恋爱专题',
    image: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20illustration%20with%20elegant%20couple%20in%20royal%20attire%2C%20palace%20garden%20setting%2C%20soft%20pink%20and%20gold%20lighting%2C%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20shojo%20aesthetic&width=1000&height=560&seq=carousel-04&orientation=landscape',
  },
  {
    title: '完结全集一次看到爽',
    subtitle: '口碑完结漫画精选合集',
    desc: '追更是快乐，完结是幸福。精选50部口碑完结漫画，从玄幻到恋爱、从悬疑到搞笑，全部免费畅读，一口气看到大结局。',
    tag: '完结专题',
    image: 'https://readdy.ai/api/search-image?query=Complete%20manga%20collection%20illustration%20with%20stacked%20comic%20books%20and%20reading%20nook%2C%20warm%20cozy%20library%20atmosphere%2C%20golden%20ambient%20lighting%2C%20satisfying%20completion%20vibe%2C%20cinematic%20widescreen&width=1000&height=560&seq=carousel-05&orientation=landscape',
  },
  {
    title: '新番上架抢先看',
    subtitle: '每月精选最新连载推荐',
    desc: '每月为你精选最新上架的热门连载。从韩漫新秀到国漫黑马，从日漫续作到原创佳作，第一手上架资讯不错过任何一部潜力神作。',
    tag: '新番专题',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20webtoon%20announcement%20illustration%20with%20vibrant%20colorful%20characters%2C%20exciting%20celebration%20atmosphere%2C%20modern%20clean%20design%2C%20warm%20coral%20and%20cream%20gradient%20background%2C%20cinematic%20widescreen&width=1000&height=560&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点专题</h2>
          <p className="text-foreground-500 text-sm mt-2">深度专题策划，发现更多精彩漫画世界</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-100/70 text-secondary-700 text-[10px] font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}